import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StIconBadge } from '../IconBadge.styled'

import type { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ComponentPropsWithoutRef } from 'react'

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard
 * ------------------------------------------------------------------------------------------------- */

type ContactInfoCardRootProps = ComponentPropsWithoutRef<'div'>

const ContactInfoCardRoot = ({ children, ...props }: ContactInfoCardRootProps) => (
  <StCardContainer {...props}>{children}</StCardContainer>
)

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard.Name
 * ------------------------------------------------------------------------------------------------- */

// TODO: the text parts are typed to 'span' instead of the Span they wrap, so a call-site cannot
// pass type or color. Widen to ComponentPropsWithoutRef<typeof Span> when one needs to.
type ContactInfoCardNameProps = ComponentPropsWithoutRef<'span'>

const ContactInfoCardName = ({ children, ...props }: ContactInfoCardNameProps) => (
  <Span type='BodyLargeBold' {...props}>
    {children}
  </Span>
)

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard.Address
 * ------------------------------------------------------------------------------------------------- */

type ContactInfoCardAddressProps = ComponentPropsWithoutRef<'span'>

const ContactInfoCardAddress = ({ children, ...props }: ContactInfoCardAddressProps) => (
  <Span type='BodyLargeRegular' {...props}>
    {children}
  </Span>
)

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard.Phone
 * ------------------------------------------------------------------------------------------------- */

type ContactInfoCardPhoneProps = ComponentPropsWithoutRef<'a'>

const ContactInfoCardPhone = ({ children, ...props }: ContactInfoCardPhoneProps) => (
  <StPhoneLink {...props}>{children}</StPhoneLink>
)

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard.PhoneNumber
 * ------------------------------------------------------------------------------------------------- */

type ContactInfoCardPhoneNumberProps = ComponentPropsWithoutRef<'span'>

const ContactInfoCardPhoneNumber = ({ children, ...props }: ContactInfoCardPhoneNumberProps) => (
  <Span type='BodyLargeRegular' {...props}>
    {children}
  </Span>
)

/* ------------------------------------------------------------------------------------------------- *
 * ContactInfoCard.Icon
 * ------------------------------------------------------------------------------------------------- */

type ContactInfoCardIconProps = ComponentPropsWithoutRef<typeof FontAwesomeIcon>

const ContactInfoCardIcon = (props: ContactInfoCardIconProps) => <StIconBadge {...props} />

const ContactInfoCard = Object.assign(ContactInfoCardRoot, {
  Name: ContactInfoCardName,
  Address: ContactInfoCardAddress,
  Phone: ContactInfoCardPhone,
  PhoneNumber: ContactInfoCardPhoneNumber,
  Icon: ContactInfoCardIcon,
})

export { ContactInfoCard }

/* ------------------------------------------------------------------------------------------------- *
 * Styled
 * ------------------------------------------------------------------------------------------------- */

const StCardContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    padding: ${theme.UI.SpacingPx.Space5};
    gap: ${theme.UI.SpacingPx.Space3};
    border: 1px solid ${theme.Components.Card.Border};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    background-color: ${theme.Components.Card.Fill};
  `}
`

const StPhoneLink = styled.a`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};
  color: inherit;
  text-decoration: none;
`
